import React from "react";
import classNames from "classnames";
import ClipLoader from "react-spinners/ClipLoader";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import APPCONFIG from "../../constants/Config";
import Types from "constants/Types";

const AD_IMAGE_SLOTS = [1, 2, 3];

export default class KioskObject extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Kiosks._name);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		const object = this.state;
		if (typeof this.props.updateName === "function") {
			this.props.updateName(object.name);
		}
	}

	getAdImageUrl = (slot) => {
		const field = `ad_image_${slot}`;
		const pendingFile = this.model && this.model.files && this.model.files[field];
		if (pendingFile && typeof pendingFile === 'object' && pendingFile.name) {
			// Local preview for a file selected but not saved yet.
			if (!this._adPreviewUrls) {
				this._adPreviewUrls = {};
			}
			if (this._adPreviewUrls[field] && this._adPreviewUrls[field].file !== pendingFile) {
				URL.revokeObjectURL(this._adPreviewUrls[field].url);
				delete this._adPreviewUrls[field];
			}
			if (!this._adPreviewUrls[field]) {
				this._adPreviewUrls[field] = {
					file: pendingFile,
					url: URL.createObjectURL(pendingFile),
				};
			}
			return this._adPreviewUrls[field].url;
		}

		if (!this.state.pkey || !this.state[field]) {
			return "";
		}

		// Authenticated PropertyImage Load_File endpoint.
		const cacheKey = encodeURIComponent(String(this.state[field]));
		return `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/kiosks/${this.state.pkey}/ad_image_${slot}?v=${cacheKey}`;
	}

	componentWillUnmount() {
		if (typeof super.componentWillUnmount === 'function') {
			super.componentWillUnmount();
		}
		if (this._adPreviewUrls) {
			Object.keys(this._adPreviewUrls).forEach((key) => {
				URL.revokeObjectURL(this._adPreviewUrls[key].url);
			});
			this._adPreviewUrls = null;
		}
	}

	deleteAdImage = (slot) => {
		if (!this.state.pkey) {
			return;
		}

		const field = `ad_image_${slot}`;
		const model = new API.BuildClass(Types.Kiosks._name, API.RequestType.DELETE);
		model.object.pkey = this.state.pkey;
		model.submit(null, `DELETE_AD_IMAGE_${slot}`).then(() => {
			if (this.model && this.model.files) {
				delete this.model.files[field];
			}
			if (this._adPreviewUrls && this._adPreviewUrls[field]) {
				URL.revokeObjectURL(this._adPreviewUrls[field].url);
				delete this._adPreviewUrls[field];
			}
			this.setState({
				[field]: "",
				[`${field}_error`]: ""
			});
		});
	}

	disconnectCheckout = () => {
		if (!this.state.pkey) {
			return;
		}

		const model = new API.BuildClass(Types.Kiosks._name, API.RequestType.UPDATE);
		model.object.pkey = this.state.pkey;
		model.submit(null, "POST_UNLINK_CHECKOUT").then(() => {
			this.setState({
				checkout: null,
				checkout_error: ""
			});
		});
	}

	handleApprovePairCode = async () => {
		if (!this.state.pkey) return;

		const pairCode = String(this.state.device_pair_code || '').replace(/\D/g, '');
		if (!/^\d{6}$/.test(pairCode)) {
			this.setState({device_pair_code_error: "Enter the 6-digit code shown on the kiosk display."});
			return;
		}

		this.setState({loading: true, device_pair_code_error: "", pair_status_message: ""});
		try {
			const kioskModel = new API.BuildClass(Types.Kiosks._name, API.RequestType.UPDATE);
			kioskModel.object.pkey = this.state.pkey;
			kioskModel.object.pair_code = pairCode;
			const data = await kioskModel.submit(null, "POST_APPROVE_PAIR", true);

			this.setState({
				loading: false,
				device_pair_code: "",
				device_pair_code_error: "",
				// Mark connected without exposing the real device token in the admin UI.
				api_key: "connected",
				pair_status_message: data && data.name
					? `Paired device to "${data.name}". The display should update shortly.`
					: "Device paired. The display should update shortly.",
			});
		} catch (e) {
			const message = (e && e.responseJSON && typeof e.responseJSON.response === "string")
				? e.responseJSON.response
				: (e && e.message) || "Unable to approve kiosk pairing.";
			this.setState({
				loading: false,
				device_pair_code_error: message === "[object Object]" ? "Unable to approve kiosk pairing." : message,
			});
		}
	}

	disconnectDevice = async () => {
		if (!this.state.pkey) {
			return;
		}

		this.setState({loading: true, device_pair_code_error: "", pair_status_message: ""});
		try {
			const kioskModel = new API.BuildClass(Types.Kiosks._name, API.RequestType.UPDATE);
			kioskModel.object.pkey = this.state.pkey;
			await kioskModel.submit(null, "POST_DISCONNECT_DEVICE", true);

			this.setState({
				loading: false,
				api_key: "",
				pair_status_message: "Device disconnected. The display will return to the pairing screen.",
			});
		} catch (e) {
			const message = (e && e.responseJSON && typeof e.responseJSON.response === "string")
				? e.responseJSON.response
				: (e && e.message) || "Unable to disconnect device.";
			this.setState({
				loading: false,
				device_pair_code_error: message === "[object Object]" ? "Unable to disconnect device." : message,
			});
		}
	}

	renderAdImageField = (slot) => {
		const object = this.state;
		const properties = this.model.properties;
		const field = `ad_image_${slot}`;

		return (
			<div className="form-group" key={field}>
				<h5 className="section-title" style={{fontSize: "1rem"}}>Ad Image {slot}</h5>
				{!object.pkey ?
					<p className="text-muted">Save the kiosk before uploading ad images.</p>
					:
					<>
						<p>
							Upload an advertisement image (JPEG or PNG).<br/>
							{object[field] ?
								<span>Current Image - <b>{object[field]}</b><br/>
									<i>Upload a new file to replace the old one.</i></span>
								: null}
						</p>
						<Framework.Elements.DropZone
							property={properties[field]}
							value={object[field]}
							error={object[`${field}_error`]}
							update={this.handleFileChange}
						/>
						{object[field] ?
							<div style={{marginTop: "12px"}}>
								<div style={{textAlign: "center"}}>
									<img
										src={this.getAdImageUrl(slot)}
										alt={`Ad ${slot}`}
										style={{maxWidth: "100%", maxHeight: "240px"}}
									/>
								</div>
								<div style={{textAlign: "-webkit-center", marginTop: "10px"}}>
									<Button
										color="danger"
										onClick={() => this.deleteAdImage(slot)}
										size={"sm"}
										block={true}
										style={{width: "fit-content"}}
									>
										Delete Image
									</Button>
								</div>
							</div>
							: null}
					</>
				}
			</div>
		);
	}

	form = () => {
		const object = this.state;
		const properties = this.model.properties;

		return (
			<div>
				<form>
					<fieldset>
						<h4 className="section-title">Kiosk</h4>
						<div className="row">
							<div className="col-md">
								<div className="form-group">
									<Framework.Elements.TextField
										name={"name"}
										label={"Name"}
										value={object.name}
										error={object.name_error}
										property={properties.name}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								{object.pkey ? (
									<>
										<div className="form-group">
											<label htmlFor="device-pair-code">Device pair code</label>
											<input
												id="device-pair-code"
												type="text"
												inputMode="numeric"
												pattern="[0-9]*"
												maxLength={6}
												className="form-control"
												value={object.device_pair_code || ""}
												onChange={(e) => {
													const value = String(e.target.value || "").replace(/\D/g, "").slice(0, 6);
													this.setState({
														device_pair_code: value,
														device_pair_code_error: "",
														pair_status_message: "",
													});
												}}
												placeholder="6-digit code from display"
												disabled={object.loading}
											/>
											{object.device_pair_code_error ?
												<div className="errorColor"><i>{object.device_pair_code_error}</i></div>
												: null}
											{object.pair_status_message ?
												<p className="text-success" style={{marginTop: "8px", marginBottom: 0}}>
													{object.pair_status_message}
												</p>
												: null}
										</div>
										<div className="form-group">
											<Button className="primary-button"
												size={"sm"}
												onClick={this.handleApprovePairCode}
												disabled={object.loading}
												style={{marginRight: "8px"}}
											>
												Approve Device
											</Button>
											{object.api_key ?
												<Button
													color="danger"
													size={"sm"}
													onClick={this.disconnectDevice}
													disabled={object.loading}
												>
													Disconnect Device
												</Button>
												: null}
											<p className="text-muted" style={{marginTop: "8px", marginBottom: 0}}>
												{object.api_key
													? "A display is currently paired. Disconnect to send it back to the pairing screen."
													: "Open kiosk on the display, then enter the code it shows here. Codes expire in 3 minutes."}
											</p>
											<p className="text-muted" style={{marginTop: "8px", marginBottom: 0}}>
												To exit kiosk mode on the display, press and hold the top-right corner for a few seconds.
											</p>
										</div>
									</>
								) : null}
							</div>
						</div>
					</fieldset>

					{object.pkey ? (
						<fieldset>
							<h4 className="section-title">Linked Checkout</h4>
							<p className="text-muted" style={{marginBottom: "16px"}}>
								Checkouts are linked from the sale screen. Admins can disconnect a kiosk here.
							</p>
							<div className="row">
								<div className="col-md">
									{object.checkout ?
										<div className="form-group">
											<p style={{marginBottom: "12px"}}>
												Currently sharing checkout <b>#{object.checkout}</b>.
											</p>
											<Button
												color="danger"
												size="sm"
												onClick={this.disconnectCheckout}
												disabled={object.loading}
											>
												Disconnect Checkout
											</Button>
										</div>
										:
										<p className="text-muted">No checkout is linked to this kiosk.</p>
									}
								</div>
							</div>
						</fieldset>
					) : null}

					<fieldset>
						<h4 className="section-title">Kiosk Content</h4>
						<p className="text-muted" style={{marginBottom: "16px"}}>
							Content saved here appears on the kiosk display after the device is approved.
						</p>
						<div className="row">
							<div className="col-md">
								<div className="form-group">
									<Framework.Elements.TextField
										name={"display_text"}
										label={"Display Text"}
										value={object.display_text}
										error={object.display_text_error}
										property={properties.display_text}
										update={this.handleTextFieldPropertyUpdate}
										multiline={6}
									/>
								</div>
								{/* Ad images temporarily disabled
								{object.pkey ? AD_IMAGE_SLOTS.map((slot) => this.renderAdImageField(slot)) : null}
								*/}
							</div>
						</div>
					</fieldset>
				</form>

				<div className={classNames("loader", {"active": object.loading})}>
					<ClipLoader color={"#4A4A4A"} loading={object.loading}/>
				</div>
			</div>
		);
	}
}
